import * as localforage from "localforage";
import axios from "axios";

export const getMonitorListApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/monitors`,
    method: "GET",
    params: {
      company_id,
      device_id
    }
  });
  return res.data;
};
export const detectMonitorApi = async device_ids => {
  let res = await axios({
    url: `/api/v2/command/detect-monitor-send`,
    method: "POST",
    data: {
      device_ids,
      execute_type: "detect_device_monitors"
    }
  });
  return res.data;
};
